export default [
  {
    element: '#some-element1',
    popover: {
      className: 'guide-navbar1',
      title: '<div   style="padding:0;margin: 0;font-family: SourceHanSansSC-regular;font-size:18px;line-height:42px;color:#101010 ;font-weight: normal">完善店铺信息</div>',
      description: `<div class="detail" style="line-height: 25px;color:#101010;font-family: SourceHanSansSC-regular;padding-bottom: 28px">
    <div style="margin: 0 0 10px 0">亲爱的老师，在店铺管理内，你可以完善知识店铺的基本信息可以帮助你的店铺有优质的介绍内容：</div>
    <div>“ 讲师店铺头像、讲师介绍，讲师简介部分为抖音规定要求必须完善的哟 ！”</div>



</div>`,
      position: 'right'
    }
  },
  {
    element: '#some-element2',
    popover: {
      className: 'guide-navbar2',
      title: '<div   style="padding:0;margin: 0;font-family: SourceHanSansSC-regular;font-size:18px;line-height:42px;color:#101010 ;font-weight: normal">上传课程内容</div>',
      description: `<div class="detail" style="line-height: 25px;color:#101010;font-family: SourceHanSansSC-regular;padding-bottom: 18px ">
    <div style="margin: 0 0 0 0">你可以在【内容管理 - 课程管理】上传新建课程或者添加新的章节课程</div>
    <div style="margin: 0 ">新功能“课程评论管理” “课程排序”</div>







</div>`,
      position: 'right'
    }
  },
  {
    element: '#some-element3',
    popover: {
      className: 'guide-navbar3',
      title: '<div   style="padding:0;margin: 0;font-family: SourceHanSansSC-regular;font-size:18px;line-height:42px;color:#101010 ;font-weight: normal">查看订单记录和收益</div>',
      description: `<div class="detail" style="line-height: 25px;color:#101010;font-family: SourceHanSansSC-regular;padding-bottom: 18px ">
   <div style="margin: 0 0 0 0">课程销售后可以在订单统计内进行查看
或获取用的基本信息，也可以在资金收益内容查看商品销售的资金情况：</div>
    <div style="margin: 0 0 0 0">查看“收益”和“提现”</div>

</div>`,
      position: 'right'
    }
  },
  {
    element: '#some-elemen4',
    popover: {
      className: 'guide-navbar4',
      title: '<div   style="padding:0;margin: 0;font-family: SourceHanSansSC-regular;font-size:18px;line-height:42px;color:#101010 ;font-weight: normal">营销功能上线了！</div>',
      description: `<div class="detail" style="line-height: 25px;color:#101010;font-family: SourceHanSansSC-regular;padding-bottom: 18px ">
   <div style="margin: 0 0 0 0">亲爱的老师，课程和商品可以进行设置
优惠券和限时抢购活动了，可以帮助提高商品销售呢！</div>
</div>`,
      position: 'right'
    }
  },
  {
    element: '#some-elemen5',
    popover: {
      className: 'guide-navbar5',
      title: '<div   style="padding:0;margin: 0;font-family: SourceHanSansSC-regular;font-size:18px;line-height:42px;color:#101010 ;font-weight: normal">资质认证已上线！</div>',
      description: `<div class="detail" style="line-height: 25px;color:#101010;font-family: SourceHanSansSC-regular;padding-bottom: 18px ">
   <div style="margin: 0">亲爱的老师，所有课程类商品需要提交或补充课程分类对应的资质信息辅助审核，新上架的课程若无资质信息可能会
影响课程审核通过。若有问题请及时咨询知视猫客服！</div>
</div>`,
      position: 'right'
    }
  },

  {
    element: '#some-elemen6',
    popover: {
      className: 'guide-navbar6',
      title: '<div   style="padding:0;margin: 0;font-family: SourceHanSansSC-regular;font-size:18px;line-height:42px;color:#101010 ;font-weight: normal">添加客服微信！</div>',
      description: `<div class="detail" style="line-height: 25px;color:#101010;font-family: SourceHanSansSC-regular;padding-bottom: 18px ">
   <div style="margin: 0 0 0 0">亲爱的老师，添加企业客服微信可以更
高效的帮助讲师了解课程审核进度和解答课程相关政策和帮助。！</div>
</div>`,
      position: 'left'
    }
  }
]

